import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import { Skeleton } from '@/components/ui/skeleton';
import { SkeletonBadge, SkeletonText, SkeletonTitle } from '@/components/ui/skeleton-base';

export default function DisputeDetailsSkeleton() {
  return (
    <div className="bg-background min-h-screen">
      <div className="flex flex-col space-y-4 sm:space-y-6">
        {/* Header */}
        <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
          <div className="flex items-center gap-4">
            <Skeleton className="h-10 w-10" />
            <div>
              <div className="flex items-center gap-3">
                <SkeletonTitle className="w-48" />
                <SkeletonBadge />
              </div>
              <SkeletonText className="mt-1 w-40" />
            </div>
          </div>
          <SkeletonBadge className="w-32" />
        </div>

        {/* Overview Card */}
        <Card className="mt-6">
          <CardHeader>
            <SkeletonTitle className="w-40" />
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
              {[...Array(6)].map((_, i) => (
                <div key={i} className="space-y-2">
                  <SkeletonText className="w-24" />
                  <SkeletonText className="w-32" />
                </div>
              ))}
            </div>
            <Separator />
            <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
              {[...Array(4)].map((_, i) => (
                <div key={i} className="space-y-2">
                  <SkeletonText className="w-24" />
                  <SkeletonText className="w-32" />
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
